import React from 'react';
import { AppBar, AppBarDataCustomItem, Button } from '@ihsm/ui-shared';
import { PageContent } from 'shared/components/PageContent';
import { InnerPagePadding } from 'shared/components/InnerPagePadding/InnerPagePadding';
import { TransparentButton } from 'shared/components/Buttons';
import saveIcon from 'shared/assets/icons/save.svg';
import { HeaderBar } from 'shared/components/HeaderBar';
import { SearchTreeReports } from '../components/SearchTreeReports';
import { NewReportForm } from '../components/NewReportForm';
import { ConfirmExitModal } from '../components/ConfirmExitModal';
import { useReportForm } from '../hooks';
import { HeaderButtonWrapper } from '../components/HeaderButtonWrapper';

export const NewReport: React.FC = () => {
  const {
    onSave,
    form,
    setForm,
    isLoading,
    isModalVisible,
    setModalVisible,
    onConfirmModal,
  } = useReportForm();

  const cancelButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <TransparentButton
          text="Cancel"
          onClick={() => setModalVisible(true)}
          iconSrc="Close"
        />
      </HeaderButtonWrapper>
    ),
  };

  const saveButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <Button
          text="Save"
          onClick={onSave}
          iconSrc={saveIcon}
          disabled={isLoading}
        />
      </HeaderButtonWrapper>
    ),
  };

  return (
    <>
      <PageContent
        searchTree={
          <SearchTreeReports
            setModalVisible={setModalVisible}
            showConfirmExitModal
            disableAddButton
          />
        }
        headerControls={
          <AppBar menuItems={[cancelButton, saveButton]}>
            <HeaderBar title="New Report" />
          </AppBar>
        }
      >
        <InnerPagePadding>
          <NewReportForm form={form} setForm={setForm} />
        </InnerPagePadding>
      </PageContent>

      <ConfirmExitModal
        isVisible={isModalVisible}
        setVisibility={setModalVisible}
        onConfirm={onConfirmModal}
      />
    </>
  );
};
